import {
  Component,
  Input,
  Output,
  EventEmitter,
  OnInit,
  SimpleChanges,
  OnChanges,
  ViewChild
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
  AbstractControl,
  ValidatorFn
} from '@angular/forms';

import { I18NextModule } from 'angular-i18next';
import i18next from 'i18next';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatRadioModule } from '@angular/material/radio';

import { LeaseInfoRestDTO, User } from 'src/app/shared/model/user.model';
import { Vehicles } from '../../../../model/vehicle.model';
import {
  CarpoolCenterDateData,
  NewRequestForm
} from 'src/app/shared/model/order.model';
import Options from 'src/app/shared/model/request-class-info.enum';
import { RequestType } from 'src/app/shared/model/requestType.enum';
import { DeliveryLocation } from 'src/app/shared/model/location.enum';
import { UserService } from 'src/app/core/services/user.service';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { Router, RouterModule } from '@angular/router';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { LoanRequestInfoComponent } from './loan-request-info/loan-request-info.component';
import { PetitionerType } from 'src/app/shared/model/petitionerType.enum';
import { StepProjectsComponent } from './step-projects/step-projects.component';
import { ProjectType } from 'src/app/shared/model/projectType.enum';
import {
  MatDatepicker,
  MatDatepickerModule
} from '@angular/material/datepicker';
import { EsRequestInfoComponent } from './es-request-info/es-request-info.component';
import { StorageService } from 'src/app/core/storage/storage.service';

@Component({
  standalone: true,
  selector: 'app-step-request-info',
  templateUrl: './step-request-info.component.html',
  styleUrls: ['./step-request-info.component.scss'],
  imports: [
    CommonModule,
    RouterModule,
    I18NextModule,
    FormsModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatSelectModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    LoanRequestInfoComponent,
    StepProjectsComponent,
    EsRequestInfoComponent
  ]
})
export class StepRequestInfoComponent implements OnInit, OnChanges {
  @ViewChild('pickerDelivery') pickerDelivery!: MatDatepicker<any>;
  @ViewChild('pickerReturn') pickerReturn!: MatDatepicker<any>;
  @ViewChild('pickerNeedDate') pickerNeedDate!: MatDatepicker<any>;

  @Input() user!: User;
  @Input() vehiclesArr?: Vehicles[];
  @Input() summaryRequest?: string;
  @Input() requestType!: string;
  @Input() stepper!: MatStepper;

  @Output() vehicleTypeEmitter = new EventEmitter<string>();
  @Output() requestInfoFormEmitter = new EventEmitter<NewRequestForm>();
  @Output() backStepEmitter = new EventEmitter();
  @Output() carPoolDataEmitter = new EventEmitter<CarpoolCenterDateData>();

  selectedVehicle?: Vehicles[];
  form: FormGroup = this.fb.group({});
  firstAssign = false;
  retributionText = '';
  options = Object.values(Options);
  maxVehiclesLeasing = 0;
  maxVehiclesEndowment = 0;
  maxVehiclesFunction = 0;
  maxVehiclesSecondaryLeasing = 1;
  spinner = false;
  loanData: any;
  max = 0;
  carPoolInfo?: CarpoolCenterDateData;
  minDate = new Date();

  requestTypeEnum = RequestType;
  petitionerTypeEnum = PetitionerType;
  projectTypeEnum = ProjectType;

  //errores
  nisErrorText = '';
  nisDsError = false;

  extraEmail = '';
  extraPhone = '';

  landing2 = false;

  public DeliveryLocation = DeliveryLocation;

  constructor(
    private fb: FormBuilder,
    private userService: UserService,
    private router: Router,
    private storageService: StorageService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes['vehiclesArr'] && !!this.vehiclesArr) {
      this.form.get('subtype')?.setValue(this.checkSubtype());
    }
  }

  ngOnInit(): void {
    this.landing2 = this.storageService.get('landing2') || false;
    const leaseInfo: LeaseInfoRestDTO[] = this.user?.leaseInfo;
    if (leaseInfo) {
      for (const item of leaseInfo) {
        if (item.type === 'LEASING') {
          this.maxVehiclesLeasing = item.maxValue;
        } else if (item.type === 'ENDOWMENT') {
          this.maxVehiclesEndowment = item.maxValue;
        } else if (item.type === 'FUNCTION') {
          this.maxVehiclesFunction = item.maxValue;
        }
      }
    }

    this.initForm();
    this.form.value.vehicles = this.vehiclesArr;

    this.form.get('subtype')?.setValue(this.checkSubtype());
    if (this.disableArrBtn() && this.disableDotBtn()) {
      this.form.get('type')?.setValue('SECONDARY_LEASING');
    } else if (this.disableArrBtn()) {
      this.form.get('type')?.setValue('ENDOWMENT');
    } else if (this.disableDotBtn()) {
      this.form.get('type')?.setValue('LEASING');
    }
  }

  changeSubtype(data: string | null) {
    data === 'FIRST_ASSIGNMENT'
      ? (this.firstAssign = true)
      : (this.firstAssign = false);
  }

  changeClass() {
    if (
      this.form.controls['class'] &&
      this.form.value.class !== 'Delegado sindical'
    ) {
      this.form.controls['nis'].reset();
      this.nisErrorText = '';
    }
  }

  setDSNis() {
    this.form.controls['nis'].invalid && this.form.controls['nis'].dirty
      ? (this.nisErrorText = i18next.t('errorWrongNis'))
      : (this.nisErrorText = '');
    if (this.form.controls['nis'].valid) {
      this.spinner = true;
      this.userService.getUserRequestDelegate(this.form.value.nis).subscribe({
        next: (resp: any) => {
          this.spinner = false;
          if (resp) {
            this.nisDsError = false;
            this.nisErrorText = '';
          } else {
            this.nisDsError = true;
            this.nisErrorText = i18next.t('errorDS');
          }
        },
        error: (err) => {
          this.spinner = false;
          if (err.error.status === 'Error') {
            this.nisErrorText = i18next.t('errorDS');
            this.nisDsError = true;
          } else {
            this.nisErrorText = '';
          }
        }
      });
    }
  }

  isFirstAssignNotAvailable = (): boolean => {
    if (this.requestType === 'FUNCTION') {
      this.max = this.maxVehiclesFunction;
    } else {
      switch (this.form.value.type) {
        case 'LEASING': {
          this.max = this.maxVehiclesLeasing;
          break;
        }
        case 'SECONDARY_LEASING': {
          this.max = 1;
          break;
        }
        case 'ENDOWMENT': {
          this.max = this.maxVehiclesEndowment;
          break;
        }
        default:
          this.max = 99;
          break;
      }
    }
    if (this.vehiclesArr) {
      return this.vehiclesArr.length >= this.max;
    } else {
      return true;
    }
  };

  vehicleType(value: string) {
    this.vehicleTypeEmitter.emit(value);
  }

  checkBtn() {
    if (
      (this.maxVehiclesLeasing > 0 && this.maxVehiclesEndowment === 0) ||
      (this.maxVehiclesLeasing > 0 && this.maxVehiclesEndowment > 0)
    ) {
      this.vehicleType('LEASING');
      return 'LEASING';
    } else if (this.maxVehiclesEndowment > 0 && this.maxVehiclesLeasing === 0) {
      this.vehicleType('ENDOWMENT');
      return 'ENDOWMENT';
    } else if (
      this.maxVehiclesEndowment === 0 &&
      this.maxVehiclesLeasing === 0
    ) {
      return null;
    } else {
      return '';
    }
  }

  private checkSubtype(): string {
    let subtype = '';
    if (this.vehiclesArr?.length === 0 && !this.isFirstAssignNotAvailable()) {
      subtype = 'FIRST_ASSIGNMENT';
    } else if (this.vehiclesArr?.length !== 0) {
      subtype = 'SUBSTITUTION';
    }
    return subtype;
  }

  retributionTranslation(retribution: string): string {
    return retribution === 'PRIMARY'
      ? (this.retributionText = 'Primaria')
      : (this.retributionText = 'Secundaria');
  }

  validateDriverLicense(control: AbstractControl) {
    return control?.value === false ? { invalidLicense: true } : null;
  }

  validateSeatEmployee(control: AbstractControl) {
    return control.value === false ? { noSeatEmployee: true } : null;
  }

  initForm(data?: any): void {
    if (
      this.requestType === this.requestTypeEnum.dotArr ||
      this.requestType === this.requestTypeEnum.campaigns
    ) {
      this.form = this.fb.group({
        type: [this.checkBtn()],
        subtype: [this.checkSubtype()],
        deliveryLocationChecked: [false],
        retribution: ['']
      });
    } else if (this.requestType === this.requestTypeEnum.transfers) {
      this.form = this.fb.group({
        deliveryDate: ['', [Validators.required]],
        returnDate: ['', [Validators.required]]
      });
    } else if (this.requestType === this.requestTypeEnum.generalServices) {
      this.form = this.fb.group({
        subtype: [this.checkSubtype()]
      });
    } else if (this.requestType === this.requestTypeEnum.innerRoute) {
      this.form = this.fb.group({
        subtype: [this.checkSubtype()],
        retribution: ['']
      });
    } else if (this.requestType === this.requestTypeEnum.judgements) {
      this.form = this.fb.group({
        location: ['', [Validators.required]],
        engine: ['', [Validators.required]],
        train: ['', [Validators.required]],
        electric: ['', [Validators.required]],
        security: ['', [Validators.required]],
        bodywork: ['', [Validators.required]],
        external: ['', [Validators.required]],
        internal: ['', [Validators.required]],
        estimatedKms: ['', [Validators.required]],
        others: ['']
      });
    } else if (this.requestType === this.requestTypeEnum.es) {
      this.form = this.fb.group({
        originCenterId: [data?.centerExit, [Validators.required]],
        destinationCenterId: [data?.centerEntry, [Validators.required]],
        checkOutDate: [data?.exitDate, [Validators.required]],
        checkInDate: [data?.entryDate, [Validators.required]],
        checkOutHour: [data?.exitHour, [Validators.required]],
        checkInHour: [data?.entryHour, [Validators.required]],
        reason: [data?.reason, [Validators.required]],
        reasonObservations: [
          data?.reasonText,
          data?.reason !== 'SUPPLIER_VISIT' ? [Validators.required] : []
        ],
        driverType: [data?.driverType, [Validators.required]],
        driverLicense: [
          data?.driver.driverLicense,
          [Validators.required, this.validateDriverLicense]
        ],
        nis: [data?.driver.nis, [Validators.required]],
        driverFullName: [data?.driver.fullName]
      });
    } else if (
      this.requestType === this.requestTypeEnum.loan &&
      data?.loanType === 'CarPool'
    ) {
      this.form = this.fb.group({
        loanType: [data.loanType, [Validators.required]],
        center: [data.center, [Validators.required]],
        deliveryDateTime: [data.deliveryDate, [Validators.required]],
        returnDateTime: [data.returnDate, [Validators.required]],
        deliveryTime: [data.deliveryHour, [Validators.required]],
        returnTime: [data.returnHour, [Validators.required]],
        reason: [data.reason, [Validators.required]],
        reasonText: [data.reasonText, [Validators.required]],
        driverType: ['INTERNAL', [Validators.required]],
        driverLicense: [
          data.driverInfo.driverLicense,
          [Validators.required, this.validateDriverLicense]
        ],
        nis: [data.driverInfo.nis, [Validators.required]],
        driverFullName: [data.driverInfo.fullName]
      });
    } else if (
      this.requestType == this.requestTypeEnum.loan &&
      data?.driverType === 'INTERNAL' &&
      data?.loanType === 'Larga Duración'
    ) {
      this.form = this.fb.group({
        loanType: [data.loanType, [Validators.required]],
        moreThan14days: [data.moreThan14days],
        totalDays: [data.totalDays],
        deliveryDate: [data.deliveryDate, [Validators.required]],
        returnDate: [data.returnDate, [Validators.required]],
        deliveryTime: [data.deliveryHour, [Validators.required]],
        returnTime: [data.returnHour, [Validators.required]],
        reason: [data.reason, [Validators.required]],
        reasonText: [
          data.reasonText,
          data.reason !== 'SUPPLIER_VISIT' ? [Validators.required] : []
        ],
        driverType: [data.driverType, [Validators.required]],
        driverLicense: [
          data.driverInfo.driverLicense,
          [Validators.required, this.validateDriverLicense]
        ],
        nis: [data.driverInfo.nis, [Validators.required]],
        driverFullName: [data.driverInfo.fullName]
      });
    } else if (
      this.requestType == this.requestTypeEnum.loan &&
      data?.driverType === 'INTERNAL' &&
      data?.loanType === 'Bodas'
    ) {
      this.form = this.fb.group({
        loanType: [data.loanType, [Validators.required]],
        deliveryDate: [data.deliveryDate, [Validators.required]],
        returnDate: [data.returnDate, [Validators.required]],
        deliveryTime: [data.deliveryHour, [Validators.required]],
        returnTime: [data.returnHour, [Validators.required]],
        spouseUserId: [data.nisContract, [Validators.required]],
        totalDays: [data.totalDays],
        seatEmployee: [
          data.seatEmployee,
          [Validators.required, this.validateSeatEmployee]
        ],
        driverType: [data.driverType, [Validators.required]],
        driverLicense: [
          data.driverInfo.driverLicense,
          [Validators.required, this.validateDriverLicense]
        ],
        nis: [data.driverInfo.nis, [Validators.required]],
        driverFullName: [data.driverInfo.fullName],
        address: [data.driverInfo.address, [Validators.required]],
        city: [data.driverInfo.city, [Validators.required]],
        postalCode: [
          data.driverInfo.postalCode,
          [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(5),
            Validators.maxLength(5)
          ]
        ]
      });
    } else if (
      this.requestType == this.requestTypeEnum.loan &&
      data?.driverType === 'EXTERNAL' &&
      data?.loanType === 'Bodas'
    ) {
      this.form = this.fb.group({
        loanType: [data.loanType, [Validators.required]],
        deliveryDate: [data.deliveryDate, [Validators.required]],
        returnDate: [data.returnDate, [Validators.required]],
        deliveryTime: [data.deliveryHour, [Validators.required]],
        returnTime: [data.returnHour, [Validators.required]],
        spouseUserId: [data.nisContract, [Validators.required]],
        totalDays: [data.totalDays],
        seatEmployee: [
          data.seatEmployee,
          [Validators.required, this.validateSeatEmployee]
        ],
        driverType: [data.driverType, [Validators.required]],
        driverLicense: [
          data.driverInfo.driverLicense,
          [Validators.required, this.validateDriverLicense]
        ],
        driverDNI: [data.driverInfo.dni, [Validators.required]],
        driverName: [data.driverInfo.name, [Validators.required]],
        driverTelephone: [
          data.driverInfo.telephone,
          [
            Validators.required,
            Validators.minLength(9),
            Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$')
          ]
        ],
        driverSurname: [data.driverInfo.lastName, [Validators.required]],
        driverEmail: [
          data.driverInfo.email,
          [
            Validators.required,
            Validators.pattern(
              '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
            )
          ]
        ],
        address: [data.driverInfo.address, [Validators.required]],
        city: [data.driverInfo.city, [Validators.required]],
        postalCode: [
          data.driverInfo.postalCode,
          [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(5),
            Validators.maxLength(5)
          ]
        ]
      });
    } else if (
      this.requestType == this.requestTypeEnum.loan &&
      data?.driverType === 'EXTERNAL' &&
      data?.loanType === 'Larga Duración'
    ) {
      this.form = this.fb.group({
        loanType: [data.loanType, [Validators.required]],
        moreThan14days: [data.moreThan14days],
        totalDays: [data.totalDays],
        deliveryDate: [data.deliveryDate, [Validators.required]],
        returnDate: [data.returnDate, [Validators.required]],
        deliveryTime: [data.deliveryHour, [Validators.required]],
        returnTime: [data.returnHour, [Validators.required]],
        reason: [data.reason, [Validators.required]],
        reasonText: [
          data.reasonText,
          data.reason !== 'SUPPLIER_VISIT' ? [Validators.required] : []
        ],
        driverType: [data.driverType, [Validators.required]],
        driverLicense: [
          data.driverInfo.driverLicense,
          [Validators.required, this.validateDriverLicense]
        ],
        driverDNI: [data.driverInfo.dni, [Validators.required]],
        driverName: [data.driverInfo.name, [Validators.required]],
        driverAddress: [data.driverInfo.address, [Validators.required]],
        driverCity: [data.driverInfo.city, [Validators.required]],
        driverTelephone: [
          data.driverInfo.telephone,
          [
            Validators.required,
            Validators.minLength(9),
            Validators.pattern('^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$')
          ]
        ],
        driverSurname: [data.driverInfo.lastName, [Validators.required]],
        driverPostalCode: [
          data.driverInfo.postalCode,
          [
            Validators.required,
            Validators.pattern('^[0-9]*$'),
            Validators.minLength(5),
            Validators.maxLength(5)
          ]
        ],
        driverEmail: [
          data.driverInfo.email,
          [
            Validators.required,
            Validators.pattern(
              '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
            )
          ]
        ]
      });
    } else if (this.requestType === 'bookVehicle') {
      this.form = this.fb.group({
        petitionerType: ['', [Validators.required]],
        name: ['', [Validators.required]],
        firstSurname: ['', [Validators.required]],
        secondSurname: ['', [Validators.required]],
        phone: [
          '',
          [
            Validators.required,
            Validators.minLength(9),
            Validators.maxLength(9),
            Validators.pattern('^[0-9]*$')
          ]
        ],
        email: [
          '',
          [
            Validators.pattern(
              '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
            ),
            Validators.required
          ]
        ]
      });
    } else if (this.requestType === RequestType.proyect) {
      this.form = this.fb.group({
        subtype: ['', [Validators.required]]
      });
      switch (data) {
        case this.projectTypeEnum.NEW:
          this.form.addControl(
            'area',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'departament',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('launch', this.fb.control(false));
          this.form.addControl(
            'dealerCode',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'ceco',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('reference', this.fb.control(''));
          this.form.addControl(
            'date',
            this.fb.control('', [Validators.required, this.minDateToday()])
          );
          this.form.addControl(
            'returnDate',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('sop', this.fb.control(''));
          this.form.addControl('cops', this.fb.control(''));
          this.form.addControl('vds', this.fb.control(''));
          this.form.addControl('kms', this.fb.control(null));
          this.form.addControl('bnr', this.fb.control(''));
          this.form.addControl(
            'finish',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('country', this.fb.control(''));
          this.form.addControl(
            'model',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('my', this.fb.control(''));
          this.form.addControl(
            'tmaimg',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('use', this.fb.control(''));
          this.form.addControl('exteriorColor', this.fb.control(''));
          this.form.addControl('interiorColor', this.fb.control(''));
          this.form.addControl('destination', this.fb.control(''));
          this.form.addControl('optionals', this.fb.control(''));
          this.form.addControl('prNumbers', this.fb.control(''));
          this.form.addControl('prMotor', this.fb.control(''));
          this.form.addControl('descriptionEngine', this.fb.control(''));
          this.form.addControl('ea', this.fb.control(''));
          this.form.addControl('registered', this.fb.control(false));
          this.form.addControl(
            'specialType',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('pressSubtype', this.fb.control(''));
          this.form.addControl('subtypeSeries', this.fb.control(''));
          this.form.addControl(
            'materialType',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'preseriesType',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'projectType',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('projectML', this.fb.control(''));
          this.form.addControl('preseriesCost', this.fb.control(null));
          this.form.addControl('seriesCost', this.fb.control(null));
          this.form.addControl('transferToThird', this.fb.control(false));
          break;
        case this.projectTypeEnum.REGU:
          this.form.addControl(
            'area',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'departament',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('launch', this.fb.control(false));
          this.form.addControl(
            'dealerCode',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'ceco',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('reference', this.fb.control(''));
          this.form.addControl(
            'date',
            this.fb.control('', [Validators.required, this.minDateToday()])
          );
          this.form.addControl('vin', this.fb.control(''));
          this.form.addControl(
            'returnDate',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('sop', this.fb.control(''));
          this.form.addControl('kms', this.fb.control(null));
          this.form.addControl('bnr', this.fb.control(''));
          this.form.addControl('finish', this.fb.control(''));
          this.form.addControl('country', this.fb.control(''));
          this.form.addControl('model', this.fb.control(''));
          this.form.addControl('my', this.fb.control(''));
          this.form.addControl('tmaimg', this.fb.control(''));
          this.form.addControl('use', this.fb.control(''));
          this.form.addControl('color', this.fb.control(''));
          this.form.addControl('destination', this.fb.control(''));
          this.form.addControl('optionals', this.fb.control(''));
          this.form.addControl('prNumbers', this.fb.control(''));
          this.form.addControl('prMotor', this.fb.control(''));
          this.form.addControl('descriptionEngine', this.fb.control(''));
          this.form.addControl('orderNumber', this.fb.control(''));
          this.form.addControl('ea', this.fb.control(''));
          this.form.addControl('cops', this.fb.control(''));
          this.form.addControl('vds', this.fb.control(''));
          this.form.addControl('registered', this.fb.control(false));
          this.form.addControl('stockVehicle', this.fb.control(false));
          break;
        case this.projectTypeEnum.OTHER:
          this.form.addControl('checkedManagement', this.fb.control(false));
          this.form.addControl('plateNumber', this.fb.control(''));
          this.form.addControl('plateNumberDate', this.fb.control(''));
          this.form.addControl('townHallCode', this.fb.control(''));
          this.form.addControl('insuranceType', this.fb.control(''));
          this.form.addControl('deliveryDate', this.fb.control(''));
          this.form.addControl(
            'brand',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('reference', this.fb.control(''));
          this.form.addControl('launch', this.fb.control(false));
          this.form.addControl(
            'dealerCode',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'ceco',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'date',
            this.fb.control('', [Validators.required, this.minDateToday()])
          );
          this.form.addControl('usePreview', this.fb.control(''));
          this.form.addControl(
            'returnDate',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('kms', this.fb.control(''));
          this.form.addControl('finishes', this.fb.control(''));
          this.form.addControl(
            'model',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('engine', this.fb.control(''));
          this.form.addControl('color', this.fb.control(''));
          this.form.addControl(
            'specialType',
            this.fb.control('', Validators.required)
          );
          this.form.addControl(
            'materialType',
            this.fb.control('', Validators.required)
          );
          this.form.addControl('subtypeSeries', this.fb.control(''));
          this.form.addControl('seriesCost', this.fb.control(null));
          this.form.addControl('emission', this.fb.control(''));
          this.form.addControl('destination', this.fb.control(''));
          this.form.addControl('cops', this.fb.control(''));
          this.form.addControl('vds', this.fb.control(''));
          this.form.addControl(
            'email',
            this.fb.control('', [
              Validators.pattern(
                '[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z]{2,4}$'
              )
            ])
          );
          this.form.addControl(
            'phone',
            this.fb.control('', [
              Validators.minLength(9),
              Validators.maxLength(9),
              Validators.pattern('^[0-9]*$')
            ])
          );
          break;
      }
    } else if (this.requestType === RequestType.redPlates) {
      this.form = this.fb.group({
        date: [, [Validators.required]],
        numberPlates: [
          0,
          [Validators.required, Validators.pattern('^[0-9]*$')]
        ],
        numberAddBulletins: [, [Validators.pattern('^[0-9]*$')]],
        numberTriplePlates: [, [Validators.pattern('^[0-9]*$')]]
      });
    } else {
      this.form = this.fb.group({
        type: [this.requestType],
        class: ['', [Validators.required]],
        nis: ['', [Validators.minLength(6), Validators.maxLength(6)]],
        subtype: [this.checkSubtype()],
        retribution: ['']
      });
    }
    if (this.disableSubstitution()) {
      this.form.get('subtype')?.setValue(null);
    }
  }

  minDateToday(): ValidatorFn {
    //Validador para controlar que la fecha de necesidad no sea menor a hoy
    return (control: AbstractControl): { [key: string]: any } | null => {
      const inputDate = new Date(control.value);
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (inputDate < today) {
        return { minDateToday: { value: control.value } };
      }

      return null;
    };
  }

  minDateNeed(needDate: string): ValidatorFn {
    //Validador para controlar que la fecha de devolución no sea menor a la de necesidad
    return (control: AbstractControl): { [key: string]: any } | null => {
      const inputDateStr = control.value;

      if (!inputDateStr || !needDate) {
        return null;
      }

      const inputDate = new Date(inputDateStr);
      const otherDate = new Date(needDate);

      if (inputDate < otherDate) {
        return {
          minDateNeed: {
            value: control.value
          }
        };
      }

      return null;
    };
  }

  isDelegated(): boolean {
    return this.form.value.class === 'Delegado Sindical' ? true : false;
  }

  disableArrBtn() {
    return this.maxVehiclesLeasing === 0;
  }

  disableDotBtn() {
    return this.maxVehiclesEndowment === 0 || this.user.groupType === 'EXP';
  }

  disableSubstitution() {
    if (this.requestType === this.requestTypeEnum.dotArr) {
      return (
        (this.maxVehiclesLeasing === 0 && this.maxVehiclesEndowment === 0) ||
        this.vehiclesArr?.length === 0
      );
    } else {
      return this.vehiclesArr?.length === 0;
    }
  }

  updateLoanInfo(data: any) {
    let startDate: any;
    let endDate: any;
    if (data.reason !== 'SUPPLIER_VISIT') {
      this.form.get('reasonText')?.setValidators(Validators.required);
      this.form.get('reasonText')?.updateValueAndValidity();
    }
    this.initForm(data);
    if (data.deliveryHour) {
      const [hours, minutes] = data.deliveryHour.split(':').map(Number);
      data.deliveryDate.setHours(hours);
      data.deliveryDate.setMinutes(minutes);
      data.deliveryDate.toUTCString();
      startDate = new Date(data.deliveryDate).toISOString();
      this.form.patchValue({ deliveryDate: startDate });
    }
    if (data.returnHour) {
      const [hours, minutes] = data.returnHour.split(':').map(Number);
      data.returnDate.setHours(hours);
      data.returnDate.setMinutes(minutes);
      data.returnDate.toUTCString();
      endDate = new Date(data.returnDate).toISOString();
      this.form.patchValue({ returnDate: endDate });
    }
    this.carPoolInfo = {
      center: data.center,
      deliveryDateTime: startDate,
      returnDateTime: endDate
    };
    this.carPoolDataEmitter.emit(this.carPoolInfo);
  }

  updateEsInfo(data: any) {
    let startDate: any;
    let endDate: any;
    if (data.reason !== 'SUPPLIER_VISIT') {
      this.form.get('reasonText')?.setValidators(Validators.required);
      this.form.get('reasonText')?.updateValueAndValidity();
    }
    this.initForm(data);

    if (data.exitHour) {
      const [hours, minutes] = data.exitHour.split(':').map(Number);
      data.exitDate.setHours(hours);
      data.exitDate.setMinutes(minutes);
      data.exitDate.toUTCString();
      startDate = new Date(data.exitDate).toISOString();
      this.form.patchValue({ exitDate: startDate });
    }
    if (data.entryHour) {
      const [hours, minutes] = data.entryHour.split(':').map(Number);
      data.entryDate.setHours(hours);
      data.entryDate.setMinutes(minutes);
      data.entryDate.toUTCString();
      endDate = new Date(data.entryDate).toISOString();
      this.form.patchValue({ entryDate: endDate });
    }
  }

  nextStep() {
    if (this.requestType === this.requestTypeEnum.function) {
      if (this.form.valid && !this.nisDsError) {
        this.requestInfoFormEmitter.emit(this.form.value);
      }
    } else {
      if (this.form.value.loanType === 'CarPool') {
        this.form.patchValue({
          deliveryDateTime: this.carPoolInfo?.deliveryDateTime,
          returnDateTime: this.carPoolInfo?.returnDateTime
        });
      }
      if (this.form.valid) {
        this.requestInfoFormEmitter.emit(this.form.value);
      }
    }
  }

  changeDateTransfers(type: string) {
    if (type === 'deliveryDate') {
      this.form.get('returnDate')!.setValue('');
      this.form
        .get('returnDate')!
        .setValidators([
          Validators.required,
          Validators.min(this.form.controls['deliveryDate'].value)
        ]);
    }
  }
  close(type: string) {
    if (type === 'pickerDelivery') {
      this.pickerDelivery['_destroyOverlay']();
    } else if (type === 'pickerReturn') {
      this.pickerReturn['_destroyOverlay']();
    } else {
      this.pickerNeedDate['_destroyOverlay']();
    }
  }
  backStep() {
    this.stepper?.selectedIndex === 0
      ? this.landing2
        ? this.router.navigateByUrl('/landing-leasing')
        : this.router.navigateByUrl('/menu')
      : this.backStepEmitter.emit();
  }

  formatDateProject(value: any): string {
    if (value) {
      const localDate = new Date(value);
      const formattedDate = `${localDate.getFullYear()}-${(
        localDate.getMonth() + 1
      )
        .toString()
        .padStart(2, '0')}-${localDate.getDate().toString().padStart(2, '0')}`;

      return formattedDate;
    } else {
      return '';
    }
  }

  handleFormProjectChange(formValue: any): void {
    this.initForm(formValue.subtype);
    if (formValue.subtype === this.projectTypeEnum.NEW) {
      this.form.get('subtype')?.setValue(formValue.subtype);
      this.form.get('area')?.setValue(formValue.area);
      this.form.get('departament')?.setValue(formValue.departament);
      this.form.get('launch')?.setValue(formValue.launch);
      this.form.get('dealerCode')?.setValue(formValue.dealerCode?.code);
      this.form.get('ceco')?.setValue(formValue.ceco);
      this.form.get('bnr')?.setValue(formValue.bnr);
      this.form.get('exteriorColor')?.setValue(formValue.exteriorColor);
      this.form.get('interiorColor')?.setValue(formValue.interiorColor);
      this.form.get('country')?.setValue(formValue.country);
      this.form.get('date')?.setValue(this.formatDateProject(formValue.date));
      this.form.get('descriptionEngine')?.setValue(formValue.descriptionEngine);
      this.form.get('destination')?.setValue(formValue.destination);
      this.form.get('finish')?.setValue(formValue.finish);
      this.form.get('kms')?.setValue(formValue.kms);
      this.form.get('model')?.setValue(formValue.model);
      this.form.get('my')?.setValue(formValue.my);
      this.form.get('optionals')?.setValue(formValue.optionals);
      this.form.get('prMotor')?.setValue(formValue.prMotor);
      this.form.get('prNumbers')?.setValue(formValue.prNumbers);
      this.form.get('reference')?.setValue(formValue.reference);
      this.form
        .get('returnDate')
        ?.setValue(this.formatDateProject(formValue.returnDate));
      this.form.get('sop')?.setValue(this.formatDateProject(formValue.sop));
      this.form.get('cops')?.setValue(formValue.cops);
      this.form.get('vds')?.setValue(formValue.vds);
      this.form.get('tmaimg')?.setValue(formValue.tmaimg);
      this.form.get('use')?.setValue(formValue.use);
      this.form.get('ea')?.setValue(formValue.ea);
      this.form.get('registered')?.setValue(formValue.registered);
      this.form.get('specialType')?.setValue(formValue.specialType);
      this.form.get('pressSubtype')?.setValue(formValue.pressSubtype);
      this.form.get('subtypeSeries')?.setValue(formValue.subtypeSeries);
      this.form.get('materialType')?.setValue(formValue.materialType);
      this.form.get('preseriesType')?.setValue(formValue.preseriesType);
      this.form.get('projectType')?.setValue(formValue.projectType);
      this.form.get('projectML')?.setValue(formValue.projectML);
      this.form.get('preseriesCost')?.setValue(formValue.preseriesCost);
      this.form.get('seriesCost')?.setValue(formValue.seriesCost);
      this.form.get('transferToThird')?.setValue(formValue.transferToThird);
    } else if (formValue.subtype === this.projectTypeEnum.REGU) {
      this.form.get('subtype')?.setValue(formValue.subtype);
      this.form.get('area')?.setValue(formValue.area);
      this.form.get('departament')?.setValue(formValue.departament);
      this.form.get('launch')?.setValue(formValue.launch);
      this.form.get('dealerCode')?.setValue(formValue.dealerCode?.code);
      this.form.get('ceco')?.setValue(formValue.ceco);
      this.form.get('bnr')?.setValue(formValue.bnr);
      this.form.get('vin')?.setValue(formValue.vin);
      this.form.get('color')?.setValue(formValue.color);
      this.form.get('country')?.setValue(formValue.country);
      this.form.get('date')?.setValue(this.formatDateProject(formValue.date));
      this.form.get('descriptionEngine')?.setValue(formValue.descriptionEngine);
      this.form.get('destination')?.setValue(formValue.destination);
      this.form.get('finish')?.setValue(formValue.finish);
      this.form.get('kms')?.setValue(formValue.kms);
      this.form.get('model')?.setValue(formValue.model);
      this.form.get('my')?.setValue(formValue.my);
      this.form.get('optionals')?.setValue(formValue.optionals);
      this.form.get('prMotor')?.setValue(formValue.prMotor);
      this.form.get('prNumbers')?.setValue(formValue.prNumbers);
      this.form.get('reference')?.setValue(formValue.reference);
      this.form
        .get('returnDate')
        ?.setValue(this.formatDateProject(formValue.returnDate));
      this.form.get('sop')?.setValue(this.formatDateProject(formValue.sop));
      this.form.get('tmaimg')?.setValue(formValue.tmaimg);
      this.form.get('use')?.setValue(formValue.use);
      this.form.get('orderNumber')?.setValue(formValue.orderNumber);
      this.form.get('ea')?.setValue(formValue.ea);
      this.form.get('cops')?.setValue(formValue.cops);
      this.form.get('vds')?.setValue(formValue.vds);
      this.form.get('registered')?.setValue(formValue.registered);
      this.form.get('stockVehicle')?.setValue(formValue.stockVehicle);
    } else {
      this.form.get('subtype')?.setValue(formValue.subtype);
      this.form.get('checkedManagement')?.setValue(formValue.checkedManagement);
      this.form.get('plateNumber')?.setValue(formValue.plateNumber);
      this.form
        .get('plateNumberDate')
        ?.setValue(this.formatDateProject(formValue.plateNumberDate));
      this.form.get('townHallCode')?.setValue(formValue.townHallCode);
      this.form.get('insuranceType')?.setValue(formValue.insuranceType);
      this.form
        .get('deliveryDate')
        ?.setValue(this.formatDateProject(formValue.deliveryDate));
      this.form.get('brand')?.setValue(formValue.brand);
      this.form.get('reference')?.setValue(formValue.reference);
      this.form.get('launch')?.setValue(formValue.launch);
      this.form.get('dealerCode')?.setValue(formValue.dealerCode?.code);
      this.form.get('ceco')?.setValue(formValue.ceco);
      this.form.get('date')?.setValue(this.formatDateProject(formValue.date));
      this.form.get('usePreview')?.setValue(formValue.usePreview);
      this.form
        .get('returnDate')
        ?.setValue(this.formatDateProject(formValue.returnDate));
      this.form.get('kms')?.setValue(formValue.kms);
      this.form.get('cops')?.setValue(formValue.cops);
      this.form.get('vds')?.setValue(formValue.vds);
      this.form.get('finishes')?.setValue(formValue.finishes);
      this.form.get('model')?.setValue(formValue.model);
      this.form.get('engine')?.setValue(formValue.engine);
      this.form.get('color')?.setValue(formValue.color);
      this.form.get('specialType')?.setValue(formValue.specialType);
      this.form.get('materialType')?.setValue(formValue.materialType);
      this.form.get('subtypeSeries')?.setValue(formValue.subtypeSeries);
      this.form.get('seriesCost')?.setValue(formValue.seriesCost);
      this.form.get('emission')?.setValue(formValue.emission);
      this.form.get('destination')?.setValue(formValue.destination);
      this.form.get('email')?.setValue(formValue.email);
      this.form.get('phone')?.setValue(formValue.phone);
    }
    if (this.form.get('date')?.value) {
      this.form
        .get('returnDate')
        ?.addValidators(this.minDateNeed(this.form.get('date')?.value));
      this.form.get('returnDate')?.updateValueAndValidity();
    }

    setTimeout(() => {
      if (formValue.invalid) {
        this.form.setErrors({ invalid: true });
      } else {
        this.form.setErrors(null);
      }
    }, 1000);
  }
}
